


















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BookingListFilterForm from './BookingListFilterForm.vue';
import BookingListFilterChip from './BookingListFilterChip.vue';
import BookingListCandidatesDrawer from './BookingListCandidatesDrawer.vue';
import {
  STATUSES as BOOKING_STATUSES,
  TYPES_DISPLAY,
  TYPES,
  BOOKING_PURPOSES,
} from '@/constants/booking';
import { mapState } from 'vuex';
import { jsonToQueryString } from '../../../../utils/utils';

@Component({
  components: {
    BookingListFilterForm,
    BookingListFilterChip,
    BookingListCandidatesDrawer,
  },
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
  },
  filters: {
    candidateName: (item, index) => {
      const arr = [item.first_name ?? null, item.last_name ?? null];

      const candidateName = arr.filter(Boolean).join(' ');

      if (candidateName.length == 0) {
        return `Candidate ${index + 1}`;
      }

      return candidateName;
    },
    candidateContact: (item) => {
      const arr = [item.email ?? null, item.mobile ?? null];

      return arr.filter(Boolean).join(', ');
    },
  },
})
export default class BookingListDataList extends Vue {
  @Prop() businessOid!: string;
  activeBusiness!: Model;

  // Data
  options: BookingListFilterOptions = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: 'updated_at',
    orderByDirection: 'desc',
    statuses: [],
    type: null,
    paymentMethod: null,
    candidateName: null,
    businessOid: '',
  };
  statuses = BOOKING_STATUSES;
  typesDisplay = TYPES_DISPLAY;
  types = TYPES;
  purposes = BOOKING_PURPOSES;

  showCandidateListDrawer = false;
  selectedBooking: Booking | null = null;
  resetPage = false;

  headers = [
    { text: 'Booking ID', value: 'gid' },
    {
      text: 'Risk Profile',
      value: 'risk_profile.gid',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Booking Type',
      value: 'purpose',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Number of Candidates',
      value: 'candidate_number',
      align: 'center',
      sortable: false,
      width: '10%',
    },
    {
      text: 'Status',
      value: 'status',
      align: 'left',
      sortable: false,
      width: '15%',
    },
    {
      text: 'Actions',
      value: 'actions',
      align: 'left',
      sortable: false,
      width: '10%',
      cellClass: 'row-click-stop',
    },
  ];

  @Watch('options', { immediate: false })
  watchOptions(newVal, oldVal) {
    this.resetPage =
      oldVal.query != newVal.query ||
      oldVal.statuses != newVal.statuses ||
      oldVal.candidateName != newVal.candidateName ||
      oldVal.paymentMethod != newVal.paymentMethod;

    this.options.page = this.resetPage ? 1 : this.options.page;

    history.pushState(
      {},
      '',
      this.$route.path +
        '?' +
        jsonToQueryString({
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          candidateName: this.options.candidateName,
          paymentMethod: this.options.paymentMethod,
          query: this.options.query,
          orderBy: this.options.orderBy,
          orderByDirection: this.options.orderByDirection,
          statuses: this.options.statuses,
        })
    );
  }

  // Methods
  handleFetch() {
    const options = {
      params: {
        search_name: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == 'desc'
            ? '-' + this.options.orderBy
            : this.options.orderBy,
        statuses: this.options.statuses,
        type: this.options.type,
        payment_method: this.options.paymentMethod,
        candidate_name: this.options.candidateName,
        business_oid: this.options.businessOid,
        expand: ['request_business', 'risk_profile', 'booking_candidates'],
      },
    };
    if (this.businessOid) {
      options.params['business_oid'] = this.businessOid;
    } else if (this.activeBusiness) {
      options.params['business_oid'] = this.activeBusiness.object_id;
    }
    return this.$store.dispatch('Booking/fetchList', options);
  }

  showCandidateList(booking) {
    this.showCandidateListDrawer = !this.showCandidateListDrawer;
    this.selectedBooking = booking;
  }

  toRead(oid) {
    const routeData = this.$router.resolve({
      name: 'business-booking-read',
      params: {
        bookingOid: oid,
      },
    });
    window.open(routeData.href, '_blank');
  }

  handleClick(item) {
    this.toRead(item.object_id);
  }
}
